import axiosV1 from '@/plugins/axios/configV1';

export default {
  getAllRoles() {
    return axiosV1.get('roles/all')
  },
  addRole(...payload) {
    return axiosV1.post('roles', ...payload)
  },
  // getRoles(params) {
  //   return axiosV1.get(`roles/all`, { params });
  // },
  getRole(id=null) {
    return axiosV1.get(`roles/edit/${id}`)
  },
  updateRole(id=null, ...payload) {
    return axiosV1.post(`roles/update/${id}`, ...payload)
  },
  deleteRole(id=null) {
    return axiosV1.post(`roles/delete/${id}`);
  },
  getModules(params) {
    return axiosV1.get(`modules/all`, { params });
  },
  getApprovalAccess(params) {
    return axiosV1.get(`/roles/approval-access`, { params });
  }
};
